import { render, staticRenderFns } from "./rc-info-dialog.vue?vue&type=template&id=006cf6f6&"
import script from "./rc-info-dialog.vue?vue&type=script&lang=js&"
export * from "./rc-info-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports